/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 3dec8dda00b1
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import { UploadMapping, UploadMapping$zodSchema } from "./uploadmapping.js";
import {
  UploadMappingListResponse,
  UploadMappingListResponse$zodSchema,
} from "./uploadmappinglistresponse.js";

export type ListUploadMappingsGlobals = { cloud_name?: string | undefined };

export const ListUploadMappingsGlobals$zodSchema: z.ZodType<
  ListUploadMappingsGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type ListUploadMappingsRequest = {
  folder?: string | undefined;
  next_cursor?: string | undefined;
  max_results?: number | undefined;
};

export const ListUploadMappingsRequest$zodSchema: z.ZodType<
  ListUploadMappingsRequest
> = z.object({
  folder: z.string().describe(
    "Get details of a specific mapping by folder name",
  ).optional(),
  max_results: z.int().default(10).describe(
    "The maximum number of results to return. Default is 10.",
  ),
  next_cursor: z.string().describe(
    "The cursor for pagination. Use the next_cursor value from a previous response to get the next page of results.",
  ).optional(),
});

/**
 * Upload mappings retrieved successfully
 */
export type ListUploadMappingsResponseBody =
  | UploadMapping
  | UploadMappingListResponse;

export const ListUploadMappingsResponseBody$zodSchema: z.ZodType<
  ListUploadMappingsResponseBody
> = z.union([
  UploadMapping$zodSchema,
  UploadMappingListResponse$zodSchema,
]).describe("Upload mappings retrieved successfully");

export type ListUploadMappingsResponse =
  | ApiError
  | UploadMapping
  | UploadMappingListResponse;

export const ListUploadMappingsResponse$zodSchema: z.ZodType<
  ListUploadMappingsResponse
> = z.union([
  ApiError$zodSchema,
  z.union([
    UploadMapping$zodSchema,
    UploadMappingListResponse$zodSchema,
  ]),
]);
